<h2 mat-dialog-title>{{data.name}}</h2>
<mat-dialog-content>
  <p><strong>Type:</strong> {{data.type}}</p>
  <p><strong>Ranking:</strong> {{data.ranking}}</p>
  <p><strong>Rating:</strong> {{data.rating}}</p>
  <p><strong>Location:</strong> {{data.location}}</p>
  <p><strong>Comments:</strong> {{data.comments}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
